// Module
var code = "<switch-field :disabled=\"disabled\" v-if=\"form\" @change=\"onChange()\" :label=\"name\" v-model=\"form[field]\" :validation=\"form.validation[field]\"><slot>{{ name }}</slot></switch-field>";
// Exports
export default code;